export const configTreatments = {
  type: "line",
  plugins: {
    title: {
      display: true,
      text: "Évolution des traitements (sur les 6 derniers mois)",
      font: { size: 14 },
      padding: 20,
    },
    legend: {
      position: "bottom",
      labels: { font: { size: 14 } },
    },
    datalabels: {
      display: false,
    },
  },
  responsive: true,
  scales: {
    y: {
      beginAtZero: true,
      suggestedMax: 8,
    },
  },
};

export const dataConfigTreatments = (data, parkinsonType) => {
  const isLecigimon = parkinsonType === "LECIGIMON";
  return {
    labels: data.labels,
    datasets: [
      {
        label: isLecigimon
          ? "LEDD PO + LECIGIMON (en mg)"
          : "LEVO + APO jour (en mg)",
        data: data.levoApo,
        borderColor: "#F16395",
        backgroundColor: "#F16395",
        tension: 0,
      },
      {
        label: isLecigimon ? "LEDD PO (en mg)" : "LEVODOPA jour (en mg)",
        data: data.levodopa,
        borderColor: "#44B5F2",
        backgroundColor: "#44B5F2",
        tension: 0,
      },
      {
        label: isLecigimon
          ? "LECIGIMON (en mg)"
          : "Apomorphine jour (en mg)",
        data: data.apomorphine,
        borderColor: "#F7761A",
        backgroundColor: "#F7761A",
        tension: 0,
      },
    ],
  };
};
